export default __webpack_public_path__ + "static/media/Gallery-12.017d81c8.jpeg";